import { Button, CircularProgress, TextField } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import validator from 'validator';

const LoginCard = ({
  loading,
  email,
  setEmail,
  password,
  setPassword,
  error,
  handleLogin,
  handleIdentify,
  loginStep,
  setLoginStep,
  identifyLoading,
  ssoRedirecting,
  loginDisabled,
}) => {
  const busy = loading || identifyLoading || ssoRedirecting;

  return (
    <Wrapper className="card-wrapper">
      <div className="card-wrapper-box">
        <h4>Log in to your PB Pay account</h4>

        <form
          onSubmit={(e) => {
            e.preventDefault();
            if (loginStep === 'email' && validator.isEmail(email) && !busy) {
              handleIdentify();
            } else if (
              loginStep === 'password' &&
              !loginDisabled &&
              password &&
              !loading
            ) {
              handleLogin();
            }
          }}
        >
          {loginStep === 'email' && (
            <>
              <div className="input-box">
                <TextField
                  fullWidth
                  type="email"
                  label="Email"
                  placeholder="Enter your email"
                  id="email-input"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <Button
                fullWidth
                variant="contained"
                type="submit"
                id="continue-button"
                disabled={!validator.isEmail(email) || busy}
              >
                {identifyLoading || ssoRedirecting ? (
                  <CircularProgress style={{ color: '#fff' }} size={26} />
                ) : (
                  'Continue'
                )}
              </Button>
            </>
          )}

          {loginStep === 'password' && (
            <>
              <div className="input-box email-display-box">
                <TextField
                  fullWidth
                  type="email"
                  label="Email"
                  id="email-display"
                  value={email}
                  disabled
                  InputProps={{
                    readOnly: true,
                    endAdornment: (
                      <button
                        type="button"
                        id="back-to-email-button"
                        className="inline-change-link"
                        onClick={() => {
                          setLoginStep('email');
                          setPassword('');
                        }}
                      >
                        Change
                      </button>
                    ),
                  }}
                />
              </div>
              <div className="input-box">
                <TextField
                  fullWidth
                  label="Password"
                  placeholder="Enter your password"
                  type="password"
                  id="password-input"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
              <p className="text-right">
                <Link id="forgot-password-link" to="/forgot-password">
                  Forgot Password?
                </Link>
              </p>
              <Button
                fullWidth
                variant="contained"
                type="submit"
                id="login-button"
                disabled={loginDisabled || !password || loading}
              >
                {loading ? (
                  <CircularProgress style={{ color: '#fff' }} size={26} />
                ) : (
                  'Login'
                )}
              </Button>
            </>
          )}

          <div className="privacy-policy privacy-policy--text-only">
            <p>
              By Continuing, you agree to{' '}
              <Link
                id="login-terms-link"
                to={`${process.env.REACT_APP_WEBISTE_ENDPOINT}/policy/termsOfUse`}
                target="_blank"
              >
                Terms of Use
              </Link>{' '}
              &{' '}
              <Link
                id="login-privacy-link"
                to={`${process.env.REACT_APP_WEBISTE_ENDPOINT}/policy/privacy`}
                target="_blank"
              >
                Privacy Notice
              </Link>
            </p>
          </div>
        </form>
      </div>

      <div className="sign-up-link">
        <p>
          Don't have an account?{' '}
          <Link id="signup-link" to="/signup">
            Sign Up
          </Link>
        </p>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  .card-wrapper-box {
    padding-bottom: 12px;

    @media all and (max-width: 768px) {
      padding-bottom: 10px;
    }
  }

  .privacy-policy--text-only {
    margin-bottom: 0;

    p {
      margin-left: 0;
      margin-bottom: 0;
    }
  }

  .email-display-box {
    .MuiInputBase-root {
      padding-right: 0;
    }

    .MuiInputAdornment-root {
      margin-left: 0;
    }
  }

  .inline-change-link {
    background: none;
    border: none;
    color: #0065ff;
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
    padding: 0 12px 0 8px;
    white-space: nowrap;
  }
`;
export default LoginCard;
